import { useState } from "react";
import { CrmShell } from "./CrmShell";
import { LoginGate } from "./LoginGate";
import { currentUser, isAuthed } from "./api";
import "./admin.css";

// Samodzielna aplikacja panelu CRM (poza marketingową powłoką serwisu).
export default function AdminApp() {
  const [user, setUser] = useState<string | null>(() => (isAuthed() ? currentUser() : null));

  return (
    <div className="crm" data-crm-root>
      {user ? (
        <CrmShell user={user} onLogout={() => setUser(null)} />
      ) : (
        <LoginGate onSuccess={setUser} />
      )}
    </div>
  );
}
